import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Segment, Button, Icon } from 'semantic-ui-react';

const TitleBar = (props) => {
    return (
        <>
            {
                props.approvals === true ? '' :
                    <div id="dispatch_bar">
                        <Container fluid className="m-0 p-0">
                            <Segment className="p-2">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="d-flex justify-content-between">
                                            <label className="mt-2 font-weight-normal">
                                                {props.title}
                                            </label>
                                            <div className="form-inline" style={{flexFlow: 'unset'}}>
                                                {props.children}
                                                {/* <Button as={Link} to={props.LinkName ? props.LinkName : '#'} hidden={props.hiddenNew} size="tiny" basic color="blue" icon>
                                                    <Icon name="plus" />
                                                    New
                                                </Button> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Segment>
                        </Container>
                    </div>
            }
        </>
    );
};

export default TitleBar
